import { render, staticRenderFns } from "./employee-add.vue?vue&type=template&id=ca69d6a8"
import script from "./employee-add.vue?vue&type=script&lang=js"
export * from "./employee-add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports